// Eager-load the filter pipeline's discovery indexes so the cost is paid
// once at engine init rather than at first filter call. Without this,
// the first filter-using consumer (typically `insights/ratings/disparities`)
// pays a 100-300ms (production, webpack-bundled) or 1.5-2s (test runner,
// babel-on-the-fly) tax for `require.context` to walk + import 79 filter
// modules + 30 sort modules + the package entity tree.
//
// Called from `offline/index.js#init`.

var Warm = {
	run: function() {
		// Filter rule + sort discovery indexes (require.context-driven).
		require('offline/filter/search/games/filters/query/index')
		require('offline/filter/search/games/filters/post/index')
		require('offline/filter/search/games/sorts/query/index')
		require('offline/filter/search/games/sorts/post/index')
		require('offline/filter/search/games/rules/query/index')
		require('offline/filter/search/games/rules/post/index')
		require('offline/filter/search/users/filters/query/index')
		require('offline/filter/search/users/sorts/query/index')
		require('offline/filter/search/lists/filters/query/index')
		require('offline/filter/search/lists/sorts/query/index')

		// Package entity trees — each pulls ~10-15 prepare/data/package units.
		require('offline/filter/package/games')
		require('offline/filter/package/users')
		require('offline/filter/package/lists')

		// Helpers used by the search pipeline.
		require('offline/filter/inline-search')
		require('offline/filter/collection')
		require('offline/filter/games')
	}
}

export default Warm
